import Vue from 'vue'
import Vuex from 'vuex'
import Modules from './modules'
import MutationType from './mutations-type'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {...Modules},
    strict: process.env.NODE_ENV !== 'production',
    state: {
        isOnline: true,
        prevRoute: '/',
        notification: [],
        tooltipList: []
    },

    mutations: {
        [MutationType.updateOnlineFlag](state, flag) {
            state.isOnline = flag
        },
        [MutationType.updatePrevRouter](state, router) {
            state.prevRoute = router
        },
        setNotification(state, data) {
            if (state.notification.indexOf(data) == -1) {
                state.notification.push(data)
            }
        },
        updateNotification(state, data) {
            state.notification = data;
        },
        updateListTooltip(state, data) {
            state.tooltipList = data
        }
    },
    actions: {
        updateOnlineFlag({commit}, flag) {
            commit(MutationType.updateOnlineFlag, flag)
        },
        updatePrevRouter({commit}, router) {
            commit(MutationType.updatePrevRouter, router)
        },
        setNotification({commit}, data) {
            commit('setNotification', data)
        },
        updateNotification({commit}, data) {
            commit('updateNotification', data)
        },
        updateListTooltip({commit}, data) {
            commit('updateListTooltip', data)
        }
    },
    getters: {
        notification: state => {
            return state.notification
        },
        tooltipList: state => {
            return state.tooltipList
        }

    }
})
